/**
 * Definición de loc comandos del Buscador
 */
export const SearchCommands = {
    OPEN_SEARCH: '[Search] OPEN_SEARCH',
    CLOSE_SEARCH: '[Search] CLOSE_SEARCH',
    LOAD_HTML_SEARCH_SUCCESS: '[Search] LOAD_HTML_SEARCH_SUCCESS',
    LOAD_HTML_SEARCH_ERROR: '[Search] LOAD_HTML_SEARCH_ERROR',
    BLOCK_SCROLL_BODY: '[Search] BLOCK_SCROLL_BODY',
    UNBLOCK_SCROLL_BODY: '[Search] UNBLOCK_SCROLL_BODY',
    TAG_RECORDING_SEARCH: '[Search] TAG_RECORDING_SEARCH',
    CHANGE_TEXT_SEARCH: '[Search] CHANGE_TEXT_SEARCH',
    SET_SECTION_SEARCH: '[Search] SET_SECTION_SEARCH',
    SET_SECTION_SEARCH_SUCCESS: '[Search] SET_SECTION_SEARCH_SUCCESS',
    SET_TYPE_SEARCH: '[Search] SET_TYPE_SEARCH',
    VIEW_ALL_SEARCH: '[Search] VIEW_ALL_SEARCH',
    SAVE_TRENDING_QUERIES_SEARCH: '[Search] SAVE_TRENDING_QUERIES_SEARCH',
    SAVE_TRENDING_QUERIES_SEARCH_ERROR: '[Search] SAVE_TRENDING_QUERIES_SEARCH_ERROR',
    SAVE_AUTOCOMPLETE_SEARCH: '[Search] SAVE_AUTOCOMPLETE_SEARCH',
    SAVE_AUTOCOMPLETE_SEARCH_ERROR: '[Search] SAVE_AUTOCOMPLETE_SEARCH_ERROR',
    SET_RECENT_SEARCH: '[Search] SET_RECENT_SEARCH',
    SAVE_RECENT_SEARCH: '[Search] SAVE_RECENT_SEARCH',
    REMOVE_RECENT_SEARCH: '[Search] REMOVE_RECENT_SEARCH',
    SAVE_RECENT_SEARCH_ERROR: '[Search] SAVE_RECENT_SEARCH_ERROR',
    GET_RELATED_TAGS_SEARCH: '[Search] GET_RELATED_TAGS_SEARCH',
    SAVE_RELATED_TAGS_SEARCH: '[Search] SAVE_RELATED_TAGS_SEARCH',
    SAVE_RELATED_TAGS_SEARCH_ERROR: '[Search] SAVE_RELATED_TAGS_SEARCH_ERROR',
    GET_PRODUCTS_ARRAY_SEARCH: '[Search] GET_PRODUCTS_ARRAY_SEARCH',
    GET_PRODUCTS_ARRAY_SEARCH_ERROR: '[Search] GET_PRODUCTS_ARRAY_SEARCH_ERROR',
    SAVE_QUERY_SEARCH: '[Search] SAVE_QUERY_SEARCH',
    LOAD_NEXT_PAGE_SEARCH: '[Search] LOAD_NEXT_PAGE_SEARCH',
    SAVE_QUERY_FILTERS: '[Search] SAVE_QUERY_FILTERS',
    REMOVE_QUERY_FILTERS: '[Search] REMOVE_QUERY_FILTERS',
    REMOVE_QUERY_FILTER: '[Search] REMOVE_QUERY_FILTER',
    ADD_FILTER: '[Search] ADD_FILTER',
    QUERY_TAGGING_SEARCH_SUCCESS: '[Search] QUERY_TAGGING_SEARCH_SUCCESS',
    QUERY_TAGGING_SEARCH_ERROR: '[Search] QUERY_TAGGING_SEARCH_ERROR',
    CLICK_TAGGING_SEARCH_SUCCESS: '[Search] CLICK_TAGGING_SEARCH_SUCCESS',
    CLICK_TAGGING_SEARCH_ERROR: '[Search] CLICK_TAGGING_SEARCH_ERROR',
};
